import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const OrdersBarChart = React.memo(({ data, title ,dataKeyX, dataKeyY ,barColor ,name}) => {
  return (
    <div className="card rounded-4">
      <div className="card-body">
        <h6 className="mb-3">{title}</h6>
        <div   style={{ width: "100%", maxHeight: "40vh", aspectRatio: 1 }}>  
        <ResponsiveContainer >

        <BarChart
      
          responsive
          data={data}
          margin={{
              top: 5,
              right: 0,
              left: 0,
              bottom: 5,
            }}
            >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey={dataKeyX} />
          <YAxis width="auto" />
          <Tooltip />
          <Legend />
          <Bar
            dataKey={dataKeyY}
            name={name}
            fill={barColor}
            barSize={120}   
            activeBar={{ fill: "pink", stroke: "blue" }}
            radius={[5, 5   , 0, 0]}
            />
        </BarChart>
            </ResponsiveContainer>
        </div>

      </div>
    </div>
  );
} );

export default OrdersBarChart;
